import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASEURL } from '../utils/apiURL';

// Define the initial state for categories
const initialState = {
  categories: [],
  loading: false,
  error: null,
};


// Create an asynchronous thunk to fetch categories from the API
export const fetchCategories = createAsyncThunk('categories/fetchCategories', 
async () => {
  try {
    const response = await axios.get(`${BASEURL}categories`);
    return response.data.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Error occurred while fetching categories');
  }
});

// Define the categorySlice using createSlice
const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Export the asynchronous thunk and the slice actions and reducer
export const { categoryActions } = categorySlice.actions;
export default categorySlice.reducer;